export enum EItineraryEvents {
  gridGap = '12',
  containerPadding = '8',
}
